import { render, staticRenderFns } from "./ReferralDataView.vue?vue&type=template&id=0fe4d1d0&"
import script from "./ReferralDataView.vue?vue&type=script&lang=ts&"
export * from "./ReferralDataView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports